import { param } from "jquery";

interface AjaxOptions {
  url: string;
  method?: "post" | "get";
  data?: object;
}

function ajax(options: AjaxOptions): Promise<any> {
  let url = options.url;
  let method = options.method || "get";

  let body: string = undefined;
  if (method === "get" && options.data) {
    url = `${url}?${param(options.data)}`;
  }

  if (method === "post" && options.data) {
    body = JSON.stringify(options.data);
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");

    xhr.onload = () => {
      if (xhr.status >= 300) {
        handleNonSuccess(xhr);
        return;
      }

      if (xhr.responseText) {
        resolve(JSON.parse(xhr.responseText));
      } else {
        resolve();
      }
    };

    xhr.onerror = (err: any) => {
      reject(err);
    };

    xhr.send(body);

    function handleNonSuccess(xhr: XMLHttpRequest) {
      const err = {
        statusCode: xhr.status,
        response: ""
      };

      if (xhr.responseText) {
        err.response = JSON.parse(xhr.responseText);
      }

      reject(err);
    }
  });
}

export default ajax;
